import * as React from 'react';

import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import StatusContext from '../../../contexts/StatusContext'
import DocumentAnalysisContext from '../../../contexts/DocumentAnalysisContext'
import { ProgressIcon } from '../customicons/ProgressIcon';

import "./documentanalysis.css"

export const DialogProgress= () => {

  const {
    changeLanguage,
    waitonResponse,
     isLoading,
} = React.useContext(StatusContext);

const {
  showProgressDialog,
} = React.useContext(DocumentAnalysisContext);


  return (
   
    <React.Fragment>
   
        <Dialog
          open={showProgressDialog}
         
          PaperProps={{
            component: 'form',
            onSubmit: (event) => {
              event.preventDefault();
              const formData = new FormData(event.currentTarget);
              const formJson = Object.fromEntries(formData.entries());
              const email = formJson.email;
              console.log(email);
              
            },
          }}
        >

        <ProgressIcon isLoading={isLoading} />    
        <DialogTitle className="dialogProgressTitle" style = {{fontSize:'16px', color:'maroon'}}>{changeLanguage('documentanalysis', 'preparefile')}</DialogTitle>

        <DialogContent dividers>
         
              <div>
              <label className="dialogProgressText"> {changeLanguage('documentanalysis', 'preparefiletext')} </label>
              <br></br>
              {waitonResponse}
              </div>
          
        </DialogContent>

      </Dialog>
    </React.Fragment>
    
    
  );
  
}